import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "recompact"
import { Box } from "@infotech/uikit-grid"
import cn from "classnames"
import isEmpty from "lodash/isEmpty"
import { selectCurrentList } from "src/engine/modules/lists/selectors"
import { readList } from "src/engine/modules/lists/actions/creators/read"
import { removeList } from "src/engine/modules/lists/actions/creators/remove"
import {
  DEFAULT_COLOR,
  makeTransparent,
} from "src/containers/Calendar/helpers/eventToItem"
import {
  LIST_NAME,
  getBasicUrl,
} from "src/containers/PlanType/Item/EventType/helper"
import styles from "../styles.css"

const ReadOnlyList = props => {
  const { planTypeId, readList, planTypeEventTypeList } = props
  useEffect(() => {
    readList({
      basicUrl: getBasicUrl(planTypeId),
      name: LIST_NAME,
    })
  }, [planTypeId])

  return (
    <>
      <Box loose className={styles.ReadOnlyWrapper}>
        {planTypeEventTypeList &&
          !planTypeEventTypeList.reading &&
          !isEmpty(planTypeEventTypeList.data) &&
          planTypeEventTypeList.data.map(item => (
            <Box
              loose
              className={styles.ReadOnlyItem}
              flex
              pl="2md"
              pt="5px"
              pb="1md"
            >
              <Box flex loose>
                <Box loose className={styles.CircleWrapper}>
                  <div
                    className={styles.circle}
                    style={{
                      backgroundColor: `${
                        item.color === `#fff`
                          ? DEFAULT_COLOR
                          : makeTransparent(item.color || `#fff`, 0.4)
                      }`,
                    }}
                  />
                </Box>
                <Box
                  pt="5px"
                  pr="2md"
                  loose
                  className={cn(
                    styles.SelectDropdownOptionLabel,
                    styles.CurrentReadOnlyLabel,
                  )}
                >
                  {item.name}
                </Box>
              </Box>
            </Box>
          ))}
      </Box>
    </>
  )
}

ReadOnlyList.propTypes = {
  planTypeId: PropTypes.oneOf([`string`, `number`]).isRequired,
  readList: PropTypes.func.isRequired,
  planTypeEventTypeList: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
}

export default compose(
  connect(
    state => ({
      planTypeEventTypeList: selectCurrentList(state, LIST_NAME),
    }),
    {
      readList,
      removeList,
    },
  ),
)(ReadOnlyList)
